import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Category } from "@modules/categorys/types";
import { CategoryFormValues } from "@modules/categorys/validations";

import { createCategoryService } from "./service";
import { UseCreateCategoryMutationOptions } from "./types";

export function useCreateCategoryMutation(
  options?: UseCreateCategoryMutationOptions
) {
  const { open } = useNotification();

  return useMutation<Category, ApiError, CategoryFormValues>({
    mutationFn: createCategoryService,
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
